import axios from 'axios'
import auth from './store/index'
import { Mutex } from 'async-mutex'

const mutex = new Mutex()

const fetchCompany = async store => {
    if (store.getters['auth/isAuth']) {
        await store.dispatch('company/profile/fetch')
    }

    setTimeout(_ => fetchCompany(store), 600000) // 5 min
}

const fetchSavedTokens = store => {
    let token = localStorage.getItem('token')
    let tokenExp = parseInt(localStorage.getItem('tokenExp'))
    let refreshToken = localStorage.getItem('refreshToken')

    if (!token || !tokenExp || !refreshToken) {
        return false
    }

    store.commit('auth/SET_REMEMBER', true, { root: true })
    store.commit('auth/SET_TOKENS', { token, tokenExp, refreshToken }, { root: true })

    return true
}

export default {
    install(Vue, store, router) {
        //

        const init = new Promise((resolve, reject) => {
            store.watch((state, getters) => getters['company/isLoaded'], value => {
                if (value) {
                    resolve()
                }
            })
        })

        /**
         * Интерцептор для axios, устанавливает токен в заголовоки запроса.
         * Выполняет прозрачное переполучение токенов.
         */
        const tokenInterceptor = async (request) => {
            if (request.url === 'oauth/token') {
                return request
            }

            await mutex.runExclusive(async () => {
                const itsTime = store.getters['auth/itsTimeToRefreshTokens']

                if (itsTime() === true) {
                    console.log("It's time to refresh tokens!")

                    const done = await store.dispatch('auth/refreshTokens')

                    if (done) {
                        console.log('Tokens was successfully refreshed')
                    } else {
                        console.log('Tokens cannot be refreshed')
                        router.push({ name: 'logout' })
                    }
                }
            })

            if (store.state.auth.token) {
                request.headers.Authorization = 'Bearer ' + store.state.auth.token
            }

            return request
        }

        /**
         * Интерцептор для axios, разлогинивает пользователя, когда бекенд ответил кодом 401.
         */
        const unauthenticatedInterceptor = error => {
            if (error.response.status === 401) {
                router.push({ name: 'logout' })
            }

            return Promise.reject(error)
        }

        axios.interceptors.request.use(tokenInterceptor)
        axios.interceptors.response.use(response => response, unauthenticatedInterceptor)

        store.registerModule('auth', auth)
        fetchSavedTokens(store)
        fetchCompany(store)

        router.beforeEach(async (to, from, next) => {
            const isAuth = store.getters['auth/isAuth']
            const requiresAuth = to.meta && to.meta.requiresAuth
            const availableForFeatures = to.meta && to.meta.availableForFeatures

            if (to.name === 'logout') {
                next()
            } else if (requiresAuth && !isAuth) {
                next({ name: 'login' })
            } else if (isAuth) {
                if (!to.meta.adminArea) {
                    await init
                }

                const companyFeatures = store.getters['company/features']

                if (availableForFeatures && availableForFeatures.filter(i => !companyFeatures.includes(i)).length) {
                    next({ name: 'home' })
                }

                const isSuspended = store.getters['company/suspended']

                if (to.name === 'logout') {
                    next()
                } else if (isSuspended && !store.state.auth.isAdmin) {
                    const availableWhenSuspend = to.meta && to.meta.availableWhenSuspend

                    if (availableWhenSuspend) {
                        next()
                    } else {
                        next({ name: 'suspend' })
                    }
                } else {
                    const isAdmin = store.state.auth.isAdmin
                    const isLoggedAsAdmin = store.getters['auth/isLoggedAsAdmin']

                    if (to.name === 'login' || to.name === 'forgot' || to.name === 'registration' || to.name === 'suspend') {
                        next({ name: 'home' })
                    } else if (isAdmin && !to.meta.adminArea && !isLoggedAsAdmin) {
                        next({ name: 'admin' })
                    } else {
                        next()
                    }
                }
            } else {
                next()
            }
        })

        router.beforeEach((to, from, next) => {
            const title = to.meta.title || null

            document.title = (typeof title === 'function')
                ? title(to) + ' - Telemetron Lite'
                : title
                    ? title + ' - Telemetron Lite'
                    : 'Telemetron Lite'

            next()
        })
    }
}
